<template>
	<div class="Hero" :class="classes">
		<div class="Hero-image">
			<slot name="image"></slot>
		</div>
		<div class="Hero-content">
			<slot name="content"></slot>
		</div>
		<div class="Hero-credit">
			<slot name="credit"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CloHero',
	components: {},
	props: {
		size: {
			type: String,
		},
		color: {
			type: String,
		},
		glass: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classes() {
			const classes = [];
			if (this.size) {
				classes.push('Hero--' + this.size);
			}
			if (this.color) {
				classes.push('Hero--' + this.color);
			}
			if (this.glass) {
				classes.push('Hero--glass');
			}
			return classes.join(' ');
		},
	},
};
</script>

<style lang="scss">
.Hero {
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: auto auto auto;
	// dark background to cover cases where image is not as tall as content
	background-color: $color-neutral-5;
	.Hero-image {
		grid-column: 1/2;
		grid-row: 1/2;
	}
	.Hero-content {
		grid-column: 1/2;
		grid-row: 3/4;
		background-color: $color-neutral-1;
		@include inset-md;
		display: flex;
		flex-direction: column;
		gap: $space-md;
	}
	.Hero-credit {
		grid-column: 1/2;
		grid-row: 2/3;
		background-color: $brand-color-warm-black;
		color: $color-white;
		@include text(1);
		@include inset-squish-sm;
		display: flex;
		flex-wrap: wrap;
		gap: $space-xs $space-md;
	}
	@include breakpoint(large) {
		grid-template-columns: 1fr 1fr;
		grid-template-rows: auto auto;
		.Hero-image {
			grid-column: 2/3;
			grid-row: 1/3;
			align-self: center;
		}
		.Hero-content {
			grid-column: 1/2;
			grid-row: 1/3;
			@include inset-squish-xl;
			justify-content: center;
			gap: $space-md;
		}
		.Hero-credit {
			grid-column: 2/3;
			grid-row: 2/3;
			@include text(2);
			background-color: transparentize($brand-color-warm-black, 0.4);
			backdrop-filter: blur(12px);
		}
	}
}

.Hero--1to2 {
	@include breakpoint(large) {
		grid-template-columns: 1fr 2fr;
	}
}

.Hero--3to5 {
	@include breakpoint(large) {
		grid-template-columns: 3fr 5fr;
	}
}

.Hero--5to7 {
	@include breakpoint(large) {
		grid-template-columns: 5fr 7fr;
	}
}

.Hero--sand {
	.Hero-content {
		background-color: $brand-color-sand;
	}
}

.Hero--sandTint1 {
	.Hero-content {
		background-color: $brand-color-sand-tint-1;
	}
}

.Hero--sky {
	.Hero-content {
		background-color: $brand-color-sky-blue;
	}
}

.Hero--skyTint1 {
	.Hero-content {
		background-color: $brand-color-sky-blue-tint-1;
	}
}

.Hero--skyTint2 {
	.Hero-content {
		background-color: $brand-color-sky-blue-tint-2;
	}
}

.Hero--neutral1 {
	.Hero-content {
		background-color: $color-neutral-1;
	}
}

.Hero--neutral0 {
	.Hero-content {
		background-color: $color-neutral-0;
	}
}

.Hero--ocean {
	.Hero-content {
		background-color: $color-primary-5;
	}
}

.Hero--black {
	.Hero-content {
		background-color: $brand-color-sand-dark-3;
	}
}

.Hero--glass {
	.Hero-content {
		background-color: $brand-color-warm-black;
		color: $color-white;
	}
	.Hero-image {
		overflow: hidden;
		// crop left side of image for mobile
		.Hero-image-image {
			max-width: 140%;
			margin-inline-start: -40%;
			object-fit: cover;
		}
	}
	@include breakpoint(large) {
		.Hero-content {
			grid-column: 1/2;
			grid-row: 1/3;
			background-color: transparentize($brand-color-warm-black, 0.4);
			backdrop-filter: blur(11px);
			border-inline-end: 1px solid $color-white;
			overflow: hidden;
			animation: heroSlide 0.5s ease;
		}
		.Hero-image {
			// show full image under glass effect
			.Hero-image-image {
				max-width: 100%;
				margin-inline-start: 0;
				object-fit: auto;
			}
			grid-column: 1/3;
			grid-row: 1/3;
		}
	}
}
@keyframes heroSlide {
	0% {
		transform: translateX(-20%);
		opacity: 0;
	}
	100% {
		transform: translateX(0);
		opacity: 1;
	}

}
</style>
